export const cardTypes = {
  All: {
    label: "All",
    color: "rgba(0, 0, 0, 0)",
  },
  Colorless: {
    label: "Colorless",
    color: "rgba(230, 230, 230, 0.7)",
  },
  Darkness: {
    label: "Darkness",
    color: "rgba(0, 0, 0, 0.7)",
  },
  Fire: {
    label: "Fire",
    color: "rgba(235, 79, 52, 0.7)",
  },
  Fighting: {
    label: "Fighting",
    color: "rgba(179, 131, 20, 0.7)",
  },
  Grass: {
    label: "Grass",
    color: "rgba(135, 242, 73, 0.7)",
  },
  Lightning: {
    label: "Lightning",
    color: "rgba(255, 238, 0, 0.5)",
  },
  Metal: {
    label: "Metal",
    color: "rgba(154, 154, 154, 0.8)",
  },
  Psychic: {
    label: "Psychic",
    color: "rgba(190, 69, 214, 0.7)",
  },
  Supporter: {
    label: "Supporter",
    color: "rgba(0, 0, 0, 0)",
  },
  Trainer: {
    label: "Trainer",
    color: "rgba(0, 0, 0, 0)",
  },
  Water: {
    label: "Water",
    color: "rgba(52, 198, 235, 0.7)",
  },
};
